/**
 * Middle-truncate (e.g., tx hash or address).
 * - Returns original string if it's too short to truncate.
 * - Guards against negative/NaN lengths.
 */
export const truncateAddress = (
  text: string,
  startLength: number = 6,
  endLength: number = 4,
): string => {
  if (!text) return '';

  const s = Math.max(0, startLength | 0);
  const e = Math.max(0, endLength | 0);

  if (text.length <= s + e) return text;

  const start = text.slice(0, s);
  const end = e ? text.slice(-e) : '';

  return e ? `${start}...${end}` : `${start}...`;
};

export const buildLeaderboardMap = (
  leaderboard: { walletAddress: string; discordUsername: string }[] = [],
): Record<string, string> => {
  return leaderboard.reduce(
    (acc, { walletAddress, discordUsername }) => {
      acc[walletAddress.toLowerCase()] = discordUsername;
      return acc;
    },
    {} as Record<string, string>,
  );
};

interface IPrettyTxProps {
  address: string;
  leaderboardMap?: Record<string, string>;
  startAddressLength?: number;
  endAddressLength?: number;
  discordUsernameLength?: number;
}

export const prettyTx = ({
  address,
  leaderboardMap,
  startAddressLength,
  endAddressLength,
  discordUsernameLength,
}: IPrettyTxProps): string => {
  if (!address) return '';
  if (!leaderboardMap)
    return truncateAddress(address, startAddressLength || 6, endAddressLength || 4);
  let discordUsername = leaderboardMap?.[address.toLowerCase()];
  if (discordUsername) discordUsername = '@' + discordUsername;
  if (discordUsername && discordUsername.length > discordUsernameLength) {
    discordUsername = discordUsername.slice(0, discordUsernameLength - 3) + '...';
  }
  return (
    discordUsername || truncateAddress(address, startAddressLength || 6, endAddressLength || 4)
  );
};
